import React from "react";
import { Button, Modal } from "react-bootstrap";
// import _ from 'lodash';
import './ResetPasswordDialog.css';
import { forcePasswordChangeRegx } from "../../util/util";

export default function ResetPasswordDialog(props) {

    let urlSearchParams = new URLSearchParams(document.location.href)
    let userId = urlSearchParams.get('userId')

    return (
        <Modal id="resetPasswordDialog" show={props.show} onHide={props.handleClose} centered backdrop="static" >
            <Modal.Header closeButton>
                <Modal.Title>
                    {<div className="content-title">
                        <span>{props.intl.formatMessage({ id: "reset_password" })}</span>
                    </div>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="label mgT"><span>{props.intl.formatMessage({ id: "username_email" })}</span></div>
                <div className="inputField"><input id="userName" type="text" name="name" size="30" maxLength="128" defaultValue={userId} disabled/></div>
                <div className="label mgT"><span>{props.intl.formatMessage({ id: "header_new_password" })}</span></div>
                <div className="inputField"><input id="newPassword" type="password" name="name" size="30" maxLength="128" /></div>
                <div className="label mgT"><span>{props.intl.formatMessage({ id: "header_confirm_password" })}</span></div>
                <div className="inputField"><input id="confirmPassword" type="password" name="name" size="30" maxLength="128" /></div>
                <div className="errMsg"></div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>{props.intl.formatMessage({ id: "header_cancel" })}</Button>
                <Button variant="primary" className="primaryBtn" onClick={resetPassword.bind(this, props)}>{props.intl.formatMessage({ id: "change_button" })}</Button>
            </Modal.Footer>
        </Modal>
    );
};

function resetPassword(props) {
    let mailAddress = document.getElementById("userName").value;
    let newPass = document.getElementById("newPassword").value;
    let confirmPass = document.getElementById("confirmPassword").value;
    const passwordIsInFormat = !forcePasswordChangeRegx.test(confirmPass);
    
    if (newPass !== confirmPass) {
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "error_confirm_password_incorrect" });
        return;
    } else if (passwordIsInFormat) {
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "header_password_explanation" });
        return;
    }

    document.getElementById("resetPasswordDialog").getElementsByClassName("primaryBtn")[0].disabled = true;
    let urlSearchParams = new URLSearchParams(document.location.href)
    let token = urlSearchParams.get('token')
    let body = { mailAddress: mailAddress, password: newPass, token: token };
    fetch(process.env.REACT_APP_CE_RESET_PASSWORD, {method: "PUT", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)})
    .then(response => {
        if (!response.ok) {
            document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
            if (response.status === 400) {
                document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "errCode_20004" });
            } else {
                document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "common_error_500" });
            }
        } else { 
            props.handleClose();
            props.displaySnackbar();
        }
    }).catch(e => {
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].style.visibility = 'visible';
        document.getElementById("resetPasswordDialog").getElementsByClassName("errMsg")[0].innerHTML = props.intl.formatMessage({ id: "server_error" });
    }).finally(() => {
        document.getElementById("resetPasswordDialog").getElementsByClassName("primaryBtn")[0].disabled = false;
    });
}
